import axios from "axios";

const backendBase = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${backendBase}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("bq_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x.msg || JSON.stringify(x)).join(" ");
  return typeof d === "object" ? d.msg || JSON.stringify(d) : String(d);
};
